"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeRedirectUrl = exports.isValidURL = exports.stripScriptTags = exports.sanitizer = exports.encodeUrl = void 0;
const dompurify_1 = __importDefault(require("dompurify"));
/**
 * JSX Example Usage
 * <div dangerouslySetInnerHTML={{
 *   __html: sanitize('<svg><g/onload=alert(2)//<p>'),
 * }} />
 */
const sanitizer = dompurify_1.default.sanitize;
exports.sanitizer = sanitizer;
/**
 * Helper to mainly handle XSS Attacks `?q=<script>` for `dangerouslySetInnerHTML`
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI
 * Problem is a `encodedURI`, can be run on itself creating varying results
 * a = encodeURI('<cats>') => "%3Ccats%3E"
 * b = encodeURI(a) => "%253Ccats%253E"
 */
const encodeUrl = (value) => {
    return String(value)
        .replace(/</g, '%3C')
        .replace(/>/g, '%3E')
        .replace(/"/g, '%22');
};
exports.encodeUrl = encodeUrl;
const stripScriptTags = (value) => {
    return String(value).replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
};
exports.stripScriptTags = stripScriptTags;
const isValidURL = (urlString) => {
    var _a;
    try {
        return !!((_a = new URL(urlString)) === null || _a === void 0 ? void 0 : _a.href);
    }
    catch (error) {
        return false;
    }
};
exports.isValidURL = isValidURL;
const sanitizeRedirectUrl = (redirectUrl) => {
    const { SITE_URL } = process.env;
    const homepage = typeof SITE_URL === 'string' && isValidURL(SITE_URL)
        ? new URL(SITE_URL).href
        : 'https://www.saatchiart.com';
    // accepts only http or https
    const isJavascriptAttack = /javascript:/i.test(redirectUrl);
    const isDataAttack = /data:/i.test(redirectUrl);
    const isOnCallbackAttack = /\bon\w+=/g.test(redirectUrl);
    const isScriptAttack = /<\s*script\s*>/gi.test(redirectUrl);
    if (isJavascriptAttack || isDataAttack || isOnCallbackAttack || isScriptAttack) {
        return homepage;
    }
    // Encode parameters
    const sanitizedRedirectUrl = encodeURI(redirectUrl);
    return sanitizedRedirectUrl;
};
exports.sanitizeRedirectUrl = sanitizeRedirectUrl;
